import { KeyboardEvent } from 'react';
import styled from 'styled-components';
import { u } from '../common/Units';

/**
 * Grid of cards in an article (DM objects, Minne responses), rounded like the other article blocks.
 * $columns applies in landscape, $portraitColumns in portrait
 */
const CardGrid = styled.ul<{ $columns?: number, $portraitColumns?: number }>`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(${p => p.$columns || 4}, minmax(0, 1fr));
  gap: ${u(16)};
  /* Rows keep their height when the grid is given a min-height (useStableHeight) */
  align-content: start;

  @media (orientation: portrait) {
    grid-template-columns: repeat(${p => p.$portraitColumns || 3}, minmax(0, 1fr));
  }

  & > li {
    border-radius: var(--block-radius);
  }
`;

/**
 * Open a card (role="button") with Enter or Space, like a click (which may also open a lightbox)
 */
export const onCardKeyDown = (e: KeyboardEvent<HTMLElement>) => {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    e.currentTarget.click();
  }
}

/**
 * Columns for a grid of `count` cards: never more than there are cards, so a few cards share the width
 * @param {number} count Number of cards in total (all pages)
 * @param {number} landscape Columns in landscape when there are enough cards
 * @param {number} portrait Columns in portrait when there are enough cards
 */
export const getCardColumns = (count: number, landscape: number, portrait: number) => ({
  $columns: Math.max(1, Math.min(count, landscape)),
  $portraitColumns: Math.max(1, Math.min(count, portrait))
});

export default CardGrid;
